module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailsModal) ? _c('section', [_c('div', {
    staticClass: "back_lay",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal modal_shadow"
  }, [_c('div', {
    staticClass: "modal__header clear_fix",
    on: {
      "click": function($event) {
        _vm.showCard(_vm.client._id)
      }
    }
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.client,
      "set-class": 'modal__avatar'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.client.last_name) + " " + _vm._s(_vm._f("one")(_vm.client.first_name)) + _vm._s(_vm._f("one")(_vm.client.middle_name)) + "\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCancel),
      expression: "!isCancel"
    }],
    staticClass: "modal__outer"
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [_c('ul', {
    staticClass: "modal__list"
  }, [_c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Телефон:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v("+" + _vm._s(_vm.client.phone))])]), _vm._v(" "), _c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Дата/Время:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v(_vm._s(_vm._f("moment")([_vm.visit.begin, 'X'], 'DD.MM.YY/HH:mm')))])]), _vm._v(" "), _c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Статус:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v(_vm._s(_vm._f("status")(_vm.visit.status)))])]), _vm._v(" "), _c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Стоимость визита:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v(_vm._s(_vm.visit.price))])]), _vm._v(" "), _c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Внесено:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v(_vm._s(_vm.visit.deposit))])]), _vm._v(" "), _c('li', {
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Баланс клиента:")]), _c('span', {
    staticClass: "span-text t-left"
  }, [_vm._v(_vm._s(_vm.balance))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visit.description),
      expression: "visit.description"
    }],
    staticClass: "modal__list-item"
  }, [_c('span', {
    staticClass: "span-text t-right"
  }, [_vm._v("Комментарий:")])])]), _vm._v(" "), _c('p', {
    staticClass: "modal__basic-text modal__basic-text_comment"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.visit.description) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "modal__inner  modal__inner_mb"
  }, [_c('div', {
    staticClass: "modal__btn-wrap"
  }, [(_vm.whenState(_vm.visit.status, ['came'])) ? _c('button', {
    staticClass: "modal__btn modal__btn_orange modal__btn_mr",
    on: {
      "click": _vm.startVisit
    }
  }, [_vm._v("\n\t\t\t\t\t\tПродолжить\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.whenState(_vm.visit.status, ['not_confirmed', 'confirmed'])) ? _c('button', {
    staticClass: "modal__btn modal__btn_orange modal__btn_mr",
    on: {
      "click": _vm.startVisit
    }
  }, [_vm._v("\n\t\t\t\t\t\tНачать прием\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.whenState(_vm.visit.status, ['not_confirmed', 'confirmed', 'came', 'completed'])) ? _c('button', {
    staticClass: "modal__btn modal__btn_decor",
    on: {
      "click": _vm.editVisit
    }
  }, [_vm._v("\n\t\t\t\t\t\tРедактировать\n\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal__inner"
  }, [_c('div', {
    staticClass: "modal__btn-wrap"
  }, [(_vm.whenState(_vm.visit.status, ['not_confirmed', 'confirmed'])) ? _c('button', {
    staticClass: "modal__btn modal__btn_blue_light modal__btn_mr",
    on: {
      "click": _vm.changeTime
    }
  }, [_vm._v("\n\t\t\t\t\t\tПеренести\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.whenState(_vm.visit.status, ['not_confirmed', 'confirmed'])) ? _c('button', {
    staticClass: "modal__btn modal__btn_decor modal__btn_gray",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n\t\t\t\t\t\tОтменить\n\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCancel),
      expression: "isCancel"
    }],
    staticClass: "modal__outer"
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [_c('form', {
    staticClass: "modal__form"
  }, [_c('label', {
    staticClass: "modal__label bold"
  }, [_vm._v("Укажите причину отмены:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "modal__text-area",
    attrs: {
      "placeholder": "Введите текст"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__btn-wrap"
  }, [_c('input', {
    staticClass: "modal__btn modal__btn_gray modal__btn_mr",
    attrs: {
      "type": "button",
      "value": "Отменить"
    },
    on: {
      "click": function($event) {
        _vm.sendCancel(_vm.visit)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "modal__btn modal__btn_decor",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCancel
    }
  }, [_vm._v("Назад")])])])])]), _vm._v(" "), _c('i', {
    staticClass: "modal__icon_close icon ion-close trans",
    on: {
      "click": _vm.closeModal
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-792e8b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/DetailsModal.vue
// module id = 634
// module chunks = 0